import { render, staticRenderFns } from "./MixItemListTwoColGoods.vue?vue&type=template&id=1ec9606e&scoped=true&"
import script from "./MixItemListTwoColGoods.vue?vue&type=script&lang=js&"
export * from "./MixItemListTwoColGoods.vue?vue&type=script&lang=js&"
import style0 from "./MixItemListTwoColGoods.vue?vue&type=style&index=0&id=1ec9606e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9606e",
  null
  
)

export default component.exports